const map = {
	"./areas/background-1.svg": 9428,
	"./areas/background-2.svg": 2551,
	"./areas/background-3.svg": 8166,
	"./areas/background-4.svg": 7609,
	"./areas/box-closed.svg": 4094,
	"./areas/box-open-2.svg": 7955,
	"./areas/box-open.svg": 658,
	"./areas/cabinet-1.svg": 2772,
	"./areas/cabinet-2.svg": 983,
	"./areas/clock.svg": 4076,
	"./areas/console-1.svg": 6803,
	"./areas/console-2.svg": 2144,
	"./areas/desks-1.svg": 8694,
	"./areas/desks-2.svg": 6821,
	"./areas/interface-1.svg": 1749,
	"./areas/interface-2.svg": 9878,
	"./areas/interface-3.svg": 3703,
	"./areas/interface-4.svg": 4520,
	"./areas/machine-1.svg": 3091,
	"./areas/machine-2.svg": 6992,
	"./areas/machine-3.svg": 5441,
	"./areas/machine-4-b.svg": 2183,
	"./areas/machine-4.svg": 5534,
	"./areas/machine-belt-1.svg": 3159,
	"./areas/machine-belt-2-b.svg": 1001,
	"./areas/machine-belt-2.svg": 8708,
	"./areas/monitor-1.svg": 7514,
	"./areas/monitor-2.svg": 3097,
	"./areas/pallet-lift.svg": 1338,
	"./areas/pallets-1.svg": 9889,
	"./areas/pallets-2.svg": 9522,
	"./areas/poster.svg": 4577,
	"./areas/table.svg": 7090,
	"./areas/wall-1.svg": 2284,
	"./areas/wall-2.svg": 8255,
	"./areas/wall-3.svg": 8206,
	"./areas/washing-machine-1.svg": 5863,
	"./areas/washing-machine-2-b.svg": 8249,
	"./areas/washing-machine-2.svg": 2740,
	"./areas/windows.svg": 7605,
	"./icon-arrow-down-light.svg": 6602,
	"./icon-arrow-down.svg": 2449,
	"./icon-arrow-up-light.svg": 1301,
	"./icon-arrow-up.svg": 3166,
	"./icon-check-light.svg": 5572,
	"./icon-check.svg": 3831,
	"./icon-close.svg": 7435,
	"./icon-home.svg": 6024,
	"./icon-hourglass.svg": 9209,
	"./icon-info.svg": 7341,
	"./icon-loading-blue.svg": 4252,
	"./icon-loading.svg": 6583,
	"./icon-logout.svg": 5719,
	"./icon-minus-btn.svg": 1348,
	"./icon-minus.svg": 9419,
	"./icon-plus-btn.svg": 1822,
	"./icon-plus.svg": 8973,
	"./icon-report.svg": 3087,
	"./icon-trash.svg": 8597,
	"./logo-cgl-black.png": 9581,
	"./logo-cgl-white.png": 8519,
	"./overview/background.svg": 1997,
	"./overview/filling-and-inspection-1.svg": 8003,
	"./overview/filling-and-inspection-2.svg": 3456,
	"./overview/filling-and-inspection-3.svg": 9905,
	"./overview/formulation-and-stabilization-1.svg": 791,
	"./overview/formulation-and-stabilization-2.svg": 9284,
	"./overview/office-and-storage-1.svg": 4883,
	"./overview/office-and-storage-2.svg": 2432,
	"./overview/overlay-1.svg": 6829,
	"./overview/overlay-2.svg": 2462,
	"./overview/overlay-3.svg": 399,
	"./overview/overlay-4.svg": 1024,
	"./overview/overlay.svg": 2699,
	"./overview/wash-and-sterilization-1.svg": 7112,
	"./overview/wash-and-sterilization-2.svg": 2651,
	"./rounds/animation.svg": 6091,
	"./rounds/round-1.svg": 9719,
	"./rounds/round-2.svg": 5124,
	"./rounds/round-3.svg": 3141,
	"./rounds/round-4.svg": 8218,
	"./rounds/round-5.svg": 3483,
	"./rounds/round-6.svg": 4648,
	"./rounds/round-7.svg": 3801,
	"./rounds/round-8.svg": 3246,
	"./staff/staff-1-a.svg": 232,
	"./staff/staff-1-b.svg": 1595,
	"./staff/staff-1-c.svg": 3754,
	"./staff/staff-1-d.svg": 4165,
	"./staff/staff-1-e.svg": 8532,
	"./staff/staff-2-a.svg": 851,
	"./staff/staff-2-b.svg": 3760,
	"./staff/staff-2-c.svg": 673,
	"./staff/staff-2-d.svg": 5198,
	"./staff/staff-2-e.svg": 3135,
	"./staff/staff-2-f.svg": 4108,
	"./staff/staff-3-a.svg": 5686,
	"./staff/staff-3-b.svg": 6933,
	"./staff/staff-3-c.svg": 1300,
	"./staff/staff-4-a.svg": 529,
	"./staff/staff-4-b.svg": 162,
	"./staff/staff-4-c.svg": 5331,
	"./staff/staff-4-d.svg": 1436,
	"./staff/staff-4-e.svg": 381,
	"./staff/staff-4-f.svg": 2030,
	"./staff/staff-5-a.svg": 796,
	"./staff/staff-6-a.svg": 7303,
	"./staff/staff-6-b.svg": 9092
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;